import React, { PropsWithChildren } from "react";
import { User } from "../api/identityApi.types";
import { UserContext } from "./UserContext";

interface Props {
  value: User;
}

export const UserContextProvider = ({ value, children }: PropsWithChildren<Props>) => (
  <UserContext.Provider value={value}>{children}</UserContext.Provider>
);
